/**
 * /admin/quotes — custom quote request center (iter114s.76).
 */
import React from 'react';
import { AdminLayout } from './AdminLayout';
import { QuoteRequestsTable } from './QuoteRequestsTable';

const AdminQuotes = () => (
  <AdminLayout>
    <div className="max-w-screen-2xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-[#14281D]" data-testid="admin-quotes-heading">Quotes</h1>
        <p className="text-sm text-[#1F3D2C]/70">Custom quote requests, manual pricing, reseller pricing, upsell opportunities.</p>
      </header>
      <QuoteRequestsTable />
    </div>
  </AdminLayout>
);

export default AdminQuotes;
